import { Button, Dropdown } from '@zep-us/zus';
import { CaretUpIcon, CheckSmallIcon, XSmallIcon } from '@/icons';
interface FilterOption {
  key: string;
  label: string;
  isSelected: boolean;
  onSelect: () => void;
}
interface FilterDropdownProps {
  label: string;
  hasValue: boolean;
  icon: JSX.Element;
  options: FilterOption[];
  onClear: () => void;
  disabled?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
}

/**
 * 필터 드롭다운 공통 컴포넌트 (GradeFilter, SubjectFilter 공유)
 * 선택 여부에 따른 intent, X/Caret 슬롯, 드롭다운 메뉴 렌더링 담당
 */
export const FilterDropdown = ({
  label,
  hasValue,
  icon,
  options,
  onClear,
  disabled,
  open,
  onOpenChange
}: FilterDropdownProps) => <Dropdown.Root open={open} onOpenChange={onOpenChange} data-sentry-element="unknown" data-sentry-component="FilterDropdown" data-sentry-source-file="FilterDropdown.tsx">
    <Dropdown.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="FilterDropdown.tsx">
      <Button variant="outlined" intent={hasValue ? 'alternative' : 'neutral'} size="sm" rounded="full" className="group shrink-0" leftSlot={icon} rightSlot={hasValue ? <XSmallIcon size="xs" onPointerDown={e => e.stopPropagation()} onClick={e => {
      e.stopPropagation();
      onClear();
    }} /> : <CaretUpIcon size="xs" className="group-data-[state=closed]:rotate-180" />} disabled={disabled} data-sentry-element="Button" data-sentry-source-file="FilterDropdown.tsx">
        {label}
      </Button>
    </Dropdown.Trigger>
    <Dropdown.Portal data-sentry-element="unknown" data-sentry-source-file="FilterDropdown.tsx">
      <Dropdown.Content className="max-h-[310px] w-auto min-w-[var(--radix-dropdown-menu-trigger-width)] overflow-y-auto" align="start" data-sentry-element="unknown" data-sentry-source-file="FilterDropdown.tsx">
        {options.map(option => <Dropdown.Item key={option.key} className="justify-between" onSelect={option.onSelect} checked={option.isSelected || undefined}>
            {option.label}
            {option.isSelected && <CheckSmallIcon size="xs" />}
          </Dropdown.Item>)}
      </Dropdown.Content>
    </Dropdown.Portal>
  </Dropdown.Root>;